
import { Component, Input } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule } from "@angular/router";
import { SkeletonModule } from "primeng/skeleton";
import { EventInfoResponseBody } from "../../../../../../services/types/events-management-response.type";
import { DashboardCardComponent } from "../../../../cards/dashboard-card/dashboard-card.component";
import { EventTableRowComponent } from "../../../../event-table-row/event-table-row.component";

@Component({
    selector: "app-last-events-card",
    imports: [
    SkeletonModule,
    MatIconModule,
    DashboardCardComponent,
    EventTableRowComponent,
    RouterModule
],
    templateUrl: "./last-events-card.component.html",
    styleUrl: "./last-events-card.component.scss"
})
export class LastEventsCardComponent {
  @Input() myEvents: EventInfoResponseBody[] | null = null;
}
